import { render, staticRenderFns } from "./ItemFilterOpenMyLayout.vue?vue&type=template&id=edae41f6&scoped=true"
import script from "./ItemFilterOpenMyLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterOpenMyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edae41f6",
  null
  
)

export default component.exports